import { Roles, type UserAccountFragment } from "@qw/graphql";

export const IMPERSONATORS: { [key: string]: string[] } = {
  "ahurrell@quotewell.com": ["aleonard@quotewell.com"],
  "lhartman@quotewell.com": ["cfuchs@quotewell.com"],
  "cfuchs@quotewell.com": ["lhartman@quotewell.com", "service@quotewell.com"],
  "wkorwan@quotewell.com": ["aleonard@quotewell.com"],
};

export const canImpersonate = (user: UserAccountFragment) =>
  user.roles.includes(Roles.Admin) || Object.keys(IMPERSONATORS).includes(user.email);
